export default "__VITE_ASSET__BPTsrfBy__"